import React from "react";
import { config } from "../../config";

class UserAnalytics extends React.Component {
    render() {
        return (
            <>
                <div id="warning">
                    <h2>
                        Note: If you&apos;re having issues with the user analytics page, please check if you have the right
                        permissions for QuickSight. You can send a message in{" "}
                        <a href="https://app.slack.com/client/TBEJLUFT4/C01EQNNAR35">this channel</a> to verify.
                    </h2>
                </div>
                <div style={{ width: "100%", height: "100%" }}>
                  <iframe
                      src={config.qsUserAnalyticsUrl}
                      style={{
                          border: "0",
                          width: "100%",
                          height: "100%",
                          overflow: "hidden",
                      }}
                      title="user-analytics"
                  />
                </div>
            </>
        );
    }
}

export default UserAnalytics;
